import { render, staticRenderFns } from "./MemberEditTabPersonal.vue?vue&type=template&id=6d047d13"
import script from "./MemberEditTabPersonal.vue?vue&type=script&lang=js"
export * from "./MemberEditTabPersonal.vue?vue&type=script&lang=js"
import style0 from "./MemberEditTabPersonal.vue?vue&type=style&index=0&id=6d047d13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports